<div>
  <app-nav></app-nav>
</div>
<!-- loader for module loading -->
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<div style="height: 95vh; overflow: scroll;">
  <router-outlet></router-outlet>
</div>